import React from 'react';
import UDIDropdownfield from "./UDIDropdownfield.js"

const MemberStateOfThePlacingOnTheEUMarketOfTheDevice = ({
	UDI,
	setUDI,
	forceIsEditing = null
}) => {

	const fieldName = "MemberStateOfThePlacingOnTheEUMarketOfTheDevice";
	const fieldTitle = "Member State of the Placing on the EU Market of the Device";
	const LOV = [

		{ key: "", value: "" },
		{ key: "general.country-iso-at", value: "Austria" },
		{ key: "general.country-iso-be", value: "Belgium" },
		{ key: "general.country-iso-bg", value: "Bulgaria" },
		{ key: "general.country-iso-cy", value: "Cyprus" },
		{ key: "general.country-iso-cz", value: "Czechia" },
		{ key: "general.country-iso-de", value: "Germany" },
		{ key: "general.country-iso-dk", value: "Denmark" },
		{ key: "general.country-iso-ee", value: "Estonia" },
		{ key: "general.country-iso-el", value: "Greece" },
		{ key: "general.country-iso-es", value: "Spain" },
		{ key: "general.country-iso-fi", value: "Finland" },
		{ key: "general.country-iso-fr", value: "France" },
		{ key: "general.country-iso-hr", value: "Croatia" },
		{ key: "general.country-iso-hu", value: "Hungary" },
		{ key: "general.country-iso-ie", value: "Ireland" },
		{ key: "general.country-iso-is", value: "Iceland" },
		{ key: "general.country-iso-it", value: "Italy" },
		{ key: "general.country-iso-li", value: "Liechtenstein" },
		{ key: "general.country-iso-lt", value: "Lithuania" },
		{ key: "general.country-iso-lu", value: "Luxembourg" },
		{ key: "general.country-iso-lv", value: "Latvia" },
		{ key: "general.country-iso-mt", value: "Malta" },
		{ key: "general.country-iso-nl", value: "Netherlands" },
		{ key: "general.country-iso-no", value: "Norway" },
		{ key: "general.country-iso-pl", value: "Poland" },
		{ key: "general.country-iso-pt", value: "Portugal" },
		{ key: "general.country-iso-ro", value: "Romania" },
		{ key: "general.country-iso-se", value: "Sweden" },
		{ key: "general.country-iso-si", value: "Slovenia" },
		{ key: "general.country-iso-sk", value: "Slovakia" },
		{ key: "general.country-iso-tr", value: "Turkiye" },
		{ key: "general.country-iso-xi", value: "United Kingdom (Northern Ireland)" },

	];

	return <>
		<UDIDropdownfield UDI={UDI} setUDI={setUDI} fieldTitle={fieldTitle} fieldName={fieldName} LOV={LOV} forceIsEditing={forceIsEditing} />
	</>
}


export default MemberStateOfThePlacingOnTheEUMarketOfTheDevice;


